var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-btn-container"},[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({el: '#app', offset: 0}),expression:"{el: '#app', offset: 0}"}],staticClass:"top-btn",attrs:{"href":"#"}},[_c('div',{staticClass:"in"},[_c('svgIcon',{staticClass:"icon-arrow-top",attrs:{"name":"arrow-top"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }